// extracted by mini-css-extract-plugin
module.exports = {"title":"Followings_title__2uP2l"};